define([
	"dojo/_base/declare",
	"csi/config",
	"csi/config/preferences",
	"SiteAdmin/SubtypedProperties",
], function(declare, config, configPreferences, SubtypedProperties) {

	return declare(SubtypedProperties, {
		/**
		 * @override
		 * Make custom view container specific to subtype
		 */
		_resolveView() {
			const subtypeName = this.getViewSubtypeName();
			if (subtypeName) {
				const urlSubtype = config.getSubtypeUrlByName("SpecificationDataSheet", subtypeName);
				const productType = config.getSubtypeSetting(urlSubtype, "ProductType");

				if (productType) {
					this.defView.pathHintsContext = configPreferences.getContextualPathHints("SpecificationDataSheet." + productType);
				}
			}

			this.inherited(arguments);
		}
	});
});